const firebaseConfig = {
  apiKey: "AIzaSyClNSp5N2HSV3sf1en9-UCpM1mPK-1D72Y",
  authDomain: "complete-web-client11.firebaseapp.com",
  projectId: "complete-web-client11",
  storageBucket: "complete-web-client11.appspot.com",
  messagingSenderId: "212002850052",
  appId: "1:212002850052:web:b5a9716cc4f2a0862bbc51",
};
export default firebaseConfig;
